import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.collections');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

const IGNORED_FILES = new Set(['.DS_Store', 'Thumbs.db', 'desktop.ini', '__MACOSX']);

@Component({
    selector: 'wiz-page-collections',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.collections/view.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.fab-enter {
  animation: fab-slide-up 0.2s ease-out;
}

@keyframes fab-slide-up {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
.progress-panel {
  animation: panel-slide-in 0.3s ease-out;
}

@keyframes panel-slide-in {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

input:focus {
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
}

select option {
  color: #0f172a;
  background: white;
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr !important;
  }
}`],
})
export class PageCollectionsComponent implements OnInit, OnDestroy {

    public viewMode: string = 'list';
    public listViewMode: string = 'card';

    public collections: any[] = [];
    public loading: boolean = false;

    public selected: any = null;
    public browsePath: string = '';
    public browseItems: any[] = [];
    public breadcrumbs: any[] = [];
    public browseLoading: boolean = false;

    public editingId: string = '';
    public editingName: string = '';

    public previewData: any = null;
    public previewOpen: boolean = false;

    // 새 컬렉션 생성
    public creating: boolean = false;
    public showCreateModal: boolean = false;
    public newCollectionName: string = '';
    public newCollectionDesc: string = '';

    // 컬렉션 목록 체크박스
    public selectedIds: Set<string> = new Set();
    public deleting: boolean = false;

    // 브라우즈 항목 체크박스
    public selectedBrowseKeys: Set<string> = new Set();
    public deletingBrowse: boolean = false;

    // 정렬
    public browseSortField: string = '';
    public browseSortDesc: boolean = true;

    // 다운로드 드롭다운
    public openDropdownName: string = '';
    public dropdownPos: { top: number; left: number } = { top: 0, left: 0 };

    // 드래그 앤 드롭 / 업로드
    public isDragging: boolean = false;
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public uploadTotalCount: number = 0;
    private dragCounter: number = 0;

    // 벡터 DB 삽입
    public isVectorInserting: boolean = false;
    public vectorInsertProgress: any = null;
    public vectorInsertLog: any[] = [];
    private vectorAbortController: AbortController | null = null;

    // 임베딩
    public isEmbeddingRunning: boolean = false;
    public embeddingProgress: any = null;
    public embeddingLog: any[] = [];
    private embeddingAbortController: AbortController | null = null;

    // OCR
    public ocrModels: any[] = [];
    public selectedOcrModel: string = 'gemini-2.5-flash';
    public isOcrRunning: boolean = false;
    public ocrProgress: any = null;
    public ocrLog: any[] = [];
    public ocrTotalPages: number = 0;
    public ocrDonePages: number = 0;
    private ocrAbortController: AbortController | null = null;

    // OCR 결과 뷰어
    public ocrViewerOpen: boolean = false;
    public ocrViewerData: any = null;
    public ocrViewerPage: number = 1;
    public ocrViewerPath: string = '';
    public ocrViewerLoading: boolean = false;

    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadOcrModels();
        await this.loadCollections();

        const id = WizRoute.segment?.id;
        if (id) {
            const col = this.collections.find((c: any) => c.id === id);
            if (col) {
                this.selected = col;
                this.viewMode = 'detail';
                this.browsePath = '';
                this.breadcrumbs = [];
                await this.loadBrowse();
            } else {
                this.service.href('/collections');
                return;
            }
        }

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment?.id;
                if (newId && (!this.selected || this.selected.id !== newId)) {
                    const col = this.collections.find((c: any) => c.id === newId);
                    if (col) {
                        this.selected = col;
                        this.viewMode = 'detail';
                        this.browsePath = '';
                        this.breadcrumbs = [];
                        await this.loadBrowse();
                        await this.service.render();
                    }
                } else if (!newId && this.viewMode !== 'list') {
                    this.viewMode = 'list';
                    this.selected = null;
                    this.previewOpen = false;
                    await this.service.render();
                }
            }
        });

        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    // ── 목록 뷰 모드 토글 ──

    public async toggleListViewMode() {
        this.listViewMode = this.listViewMode === 'card' ? 'table' : 'card';
        await this.service.render();
    }

    // ── 목록 ──

    public async loadCollections() {
        this.loading = true;
        this.selectedIds = new Set();
        await this.service.render();
        const { code, data } = await wiz.call('list');
        if (code === 200) this.collections = data;
        this.loading = false;
        await this.service.render();
    }

    // ── 컬렉션 체크박스 ──

    public toggleSelect(col: any, event: Event) {
        event.stopPropagation();
        if (this.selectedIds.has(col.id)) this.selectedIds.delete(col.id);
        else this.selectedIds.add(col.id);
        this.service.render();
    }

    public toggleSelectAll(event: Event) {
        event.stopPropagation();
        if (this.selectedIds.size === this.collections.length) {
            this.selectedIds = new Set();
        } else {
            this.selectedIds = new Set(this.collections.map((c: any) => c.id));
        }
        this.service.render();
    }

    public isSelected(col: any): boolean {
        return this.selectedIds.has(col.id);
    }

    public isAllSelected(): boolean {
        return this.collections.length > 0 && this.selectedIds.size === this.collections.length;
    }

    public async deleteSelected() {
        if (this.selectedIds.size === 0) return;
        const count = this.selectedIds.size;

        const res = await this.service.modal.show({
            title: '컬렉션 삭제',
            message: `선택한 ${count}개 컬렉션을 삭제하시겠습니까?\n폴더와 내부 파일이 모두 삭제됩니다.`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;

        this.deleting = true;
        await this.service.render();

        const ids = Array.from(this.selectedIds).join(',');
        const { code, data } = await wiz.call('delete', { ids });
        this.deleting = false;

        if (code === 200) {
            if (data.errors && data.errors.length > 0) {
                await this.service.modal.error(`일부 삭제 실패:\n${data.errors.join('\n')}`);
            }
            await this.loadCollections();
        } else {
            await this.service.modal.error(data?.message || '삭제에 실패했습니다.');
            await this.service.render();
        }
    }

    // ── 인라인 이름 편집 ──

    public startEdit(col: any, event: Event) {
        event.stopPropagation();
        this.editingId = col.id;
        this.editingName = col.name || '';
        this.service.render();
    }

    public cancelEdit(event?: Event) {
        if (event) event.stopPropagation();
        this.editingId = '';
        this.editingName = '';
        this.service.render();
    }

    public async saveEdit(col: any, event?: Event) {
        if (event) event.stopPropagation();
        if (!this.editingName.trim()) return;
        const { code } = await wiz.call('update_meta', {
            id: col.id,
            name: this.editingName.trim(),
            description: col.description || '',
        });
        if (code === 200) {
            col.name = this.editingName.trim();
            col.has_meta = true;
        }
        this.editingId = '';
        this.editingName = '';
        await this.service.render();
    }

    public async onEditKeydown(event: KeyboardEvent, col: any) {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.saveEdit(col);
        } else if (event.key === 'Escape') {
            this.cancelEdit();
        }
    }

    // ── 새 컬렉션 생성 ──

    public async createCollection() {
        this.newCollectionName = '';
        this.newCollectionDesc = '';
        this.showCreateModal = true;
        await this.service.render();
    }

    public async confirmCreateCollection() {
        const name = this.newCollectionName?.trim();
        if (!name) return;

        this.creating = true;
        this.showCreateModal = false;
        await this.service.render();

        const { code, data } = await wiz.call('create', { name, description: this.newCollectionDesc?.trim() || '' });
        this.creating = false;

        if (code === 200) {
            await this.loadCollections();
            this.service.href(`/collections/${data.id}`);
        } else {
            await this.service.modal.error(data?.message || '컬렉션 생성에 실패했습니다.');
            await this.service.render();
        }
    }

    // ── 상세 ──

    public async openCollection(col: any) {
        this.service.href(`/collections/${col.id}`);
    }

    public backToList() {
        this.service.href('/collections');
    }

    // ── 파일 브라우저 ──

    public async loadBrowse() {
        this.browseLoading = true;
        this.previewOpen = false;
        this.openDropdownName = '';
        this.selectedBrowseKeys = new Set();
        await this.service.render();
        const { code, data } = await wiz.call('browse', {
            id: this.selected.id,
            path: this.browsePath,
        });
        if (code === 200) this.browseItems = data;
        if (this.browseSortField) this.applyBrowseSort();
        this.updateBreadcrumbs();
        this.browseLoading = false;
        await this.service.render();

        // 루트 경로 진입 시 벡터 상태 자동 동기화
        if (!this.browsePath) this.syncVectorStatus();
    }

    // ── 벡터 DB 상태 동기화 ──

    public async syncVectorStatus() {
        const { code, data } = await wiz.call('sync_vector_status', { id: this.selected.id });
        if (code === 200 && data.synced > 0) {
            await this.loadBrowse();
        }
    }

    public async navigateFolder(item: any) {
        if (item.type === 'folder') {
            this.browsePath = item.path;
            await this.loadBrowse();
        }
    }

    public async navigateBreadcrumb(path: string) {
        this.browsePath = path;
        await this.loadBrowse();
    }

    private updateBreadcrumbs() {
        const parts = this.browsePath ? this.browsePath.split('/') : [];
        this.breadcrumbs = [];
        let accum = '';
        for (const part of parts) {
            accum = accum ? accum + '/' + part : part;
            this.breadcrumbs.push({ name: part, path: accum });
        }
    }

    // ── 브라우즈 항목 체크박스 ──

    public getBrowseKey(item: any): string {
        return item.type + ':' + (item.path || item.name);
    }

    public toggleBrowseSelect(item: any, event: Event) {
        event.stopPropagation();
        const key = this.getBrowseKey(item);
        if (this.selectedBrowseKeys.has(key)) this.selectedBrowseKeys.delete(key);
        else this.selectedBrowseKeys.add(key);
        this.service.render();
    }

    public toggleBrowseSelectAll(event: Event) {
        event.stopPropagation();
        if (this.isAllBrowseSelected()) {
            this.selectedBrowseKeys = new Set();
        } else {
            this.selectedBrowseKeys = new Set(this.browseItems.map((i: any) => this.getBrowseKey(i)));
        }
        this.service.render();
    }

    public isBrowseSelected(item: any): boolean {
        return this.selectedBrowseKeys.has(this.getBrowseKey(item));
    }

    public isAllBrowseSelected(): boolean {
        return this.browseItems.length > 0 && this.selectedBrowseKeys.size === this.browseItems.length;
    }

    public async deleteBrowseSelected() {
        if (this.selectedBrowseKeys.size === 0) return;
        const count = this.selectedBrowseKeys.size;

        const res = await this.service.modal.show({
            title: '항목 삭제',
            message: `선택한 ${count}개 항목을 삭제하시겠습니까?\n삭제된 항목은 복구할 수 없습니다.`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;

        this.deletingBrowse = true;
        await this.service.render();

        const paths: string[] = [];
        for (const item of this.browseItems) {
            if (!this.isBrowseSelected(item)) continue;
            if (item.type === 'folder') {
                paths.push(item.path);
            } else if (item.type === 'filegroup') {
                for (const v of item.variants) paths.push(v.path);
            }
        }

        const { code, data } = await wiz.call('delete_items', {
            id: this.selected.id,
            paths: JSON.stringify(paths),
        });
        this.deletingBrowse = false;

        if (code === 200) {
            if (data.errors?.length > 0) {
                await this.service.modal.error(`일부 삭제 실패:\n${data.errors.join('\n')}`);
            }
            await this.loadBrowse();
        } else {
            await this.service.modal.error(data?.message || '삭제에 실패했습니다.');
            await this.service.render();
        }
    }

    // ── 폴더 생성 ──

    public async createFolder() {
        const name = prompt('새 폴더 이름을 입력하세요:');
        if (!name || !name.trim()) return;

        const { code, data } = await wiz.call('create_folder', {
            id: this.selected.id,
            path: this.browsePath,
            name: name.trim(),
        });

        if (code === 200) {
            await this.loadBrowse();
        } else {
            await this.service.modal.error(data?.message || '폴더 생성에 실패했습니다.');
        }
    }

    // ── 드래그 앤 드롭 ──

    public onDragEnter(event: DragEvent) {
        event.preventDefault();
        this.dragCounter++;
        if (!this.isDragging) {
            this.isDragging = true;
            this.service.render();
        }
    }

    public onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    public onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.dragCounter--;
        if (this.dragCounter <= 0) {
            this.dragCounter = 0;
            this.isDragging = false;
            this.service.render();
        }
    }

    public async onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        // dataTransfer는 await 전에 동기적으로 읽어야 함 (브라우저가 drag data store를 정리하기 전)
        const items = event.dataTransfer?.items;
        const entries: any[] = [];
        const fallbackFiles: File[] = [];

        if (items) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i] as any;
                const entry = item.webkitGetAsEntry?.() || item.getAsEntry?.();
                if (entry) {
                    entries.push(entry);
                } else if (item.kind === 'file') {
                    const file = item.getAsFile();
                    if (file) fallbackFiles.push(file);
                }
            }
        }

        this.isDragging = false;
        this.dragCounter = 0;
        await this.service.render();

        const fileEntries: { file: File, path: string }[] = [];

        // Entry API로 폴더 재귀 탐색
        for (const entry of entries) {
            await this.readEntry(entry, '', fileEntries);
        }

        // Entry API 미지원 시 fallback (파일만 가능)
        for (const file of fallbackFiles) {
            if (file.name && !IGNORED_FILES.has(file.name) && !file.name.startsWith('._')) {
                fileEntries.push({ file, path: file.name });
            }
        }

        if (fileEntries.length > 0) {
            await this.uploadFiles(fileEntries);
        }
    }

    private readEntry(entry: any, basePath: string, files: { file: File, path: string }[]): Promise<void> {
        return new Promise((resolve) => {
            // 시스템 파일/폴더 필터링
            if (IGNORED_FILES.has(entry.name) || entry.name.startsWith('._')) {
                resolve();
                return;
            }

            if (entry.isFile) {
                entry.file((file: File) => {
                    const path = basePath ? basePath + '/' + file.name : file.name;
                    files.push({ file, path });
                    resolve();
                }, () => resolve());
            } else if (entry.isDirectory) {
                const dirPath = basePath ? basePath + '/' + entry.name : entry.name;
                const reader = entry.createReader();
                this.readAllEntries(reader).then(async (childEntries) => {
                    for (const child of childEntries) {
                        await this.readEntry(child, dirPath, files);
                    }
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    private readAllEntries(reader: any): Promise<any[]> {
        return new Promise((resolve) => {
            const results: any[] = [];
            const readBatch = () => {
                reader.readEntries((entries: any[]) => {
                    if (entries.length === 0) resolve(results);
                    else { results.push(...entries); readBatch(); }
                }, () => resolve(results));
            };
            readBatch();
        });
    }

    // ── 파일 선택 (input) ──

    public async onFileSelect(event: any) {
        const input = event.target;
        if (!input.files || input.files.length === 0) return;

        const fileEntries: { file: File, path: string }[] = [];
        for (let i = 0; i < input.files.length; i++) {
            const file = input.files[i];
            fileEntries.push({ file, path: file.name });
        }

        input.value = '';
        if (fileEntries.length > 0) await this.uploadFiles(fileEntries);
    }

    // ── 업로드 (XHR + 진행률) ──

    private async uploadFiles(fileEntries: { file: File, path: string }[]) {
        // 프론트에서도 시스템 파일 필터링 (이중 방어)
        fileEntries = fileEntries.filter(e => {
            const parts = e.path.split('/');
            return !parts.some(p => IGNORED_FILES.has(p) || p.startsWith('._'));
        });
        if (fileEntries.length === 0) return;

        this.uploading = true;
        this.uploadProgress = 0;
        this.uploadTotalCount = fileEntries.length;
        await this.service.render();

        const formData = new FormData();
        for (const entry of fileEntries) {
            formData.append('files[]', entry.file, entry.path);
        }

        const url = `/wiz/api/page.collections/upload?id=${encodeURIComponent(this.selected.id)}&path=${encodeURIComponent(this.browsePath)}`;

        try {
            const result: any = await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', url);

                xhr.upload.onprogress = (e: ProgressEvent) => {
                    if (e.lengthComputable) {
                        this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                        this.service.render();
                    }
                };

                xhr.onload = () => {
                    try { resolve(JSON.parse(xhr.responseText)); }
                    catch { reject(new Error('응답 파싱 실패')); }
                };

                xhr.onerror = () => reject(new Error('네트워크 오류'));
                xhr.send(formData);
            });

            this.uploading = false;

            if (result.code === 200) {
                if (result.data?.errors?.length > 0) {
                    await this.service.modal.error(`일부 업로드 실패:\n${result.data.errors.join('\n')}`);
                }
                await this.loadBrowse();
            } else {
                await this.service.modal.error(result.data?.message || '업로드에 실패했습니다.');
                await this.service.render();
            }
        } catch (e) {
            this.uploading = false;
            await this.service.modal.error('업로드 중 오류가 발생했습니다.');
            await this.service.render();
        }
    }

    // ── 다운로드 드롭다운 ──

    public toggleDropdown(name: string, event: Event) {
        event.stopPropagation();
        if (this.openDropdownName === name) {
            this.openDropdownName = '';
        } else {
            this.openDropdownName = name;
            const btn = (event.currentTarget || event.target) as HTMLElement;
            const rect = btn.getBoundingClientRect();
            this.dropdownPos = { top: rect.bottom + 4, left: rect.right - 220 };
        }
        this.service.render();
    }

    public closeDropdown() {
        this.openDropdownName = '';
        this.service.render();
    }

    public async downloadFile(variant: any, event: Event) {
        event.stopPropagation();
        this.openDropdownName = '';

        const url = `/wiz/api/page.collections/download?id=${encodeURIComponent(this.selected.id)}&path=${encodeURIComponent(variant.path)}`;
        const a = document.createElement('a');
        a.href = url;
        a.download = variant.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        await this.service.render();
    }

    public async previewVariant(variant: any, event: Event) {
        event.stopPropagation();
        this.openDropdownName = '';
        const { code, data } = await wiz.call('file_preview', {
            id: this.selected.id,
            path: variant.path,
        });
        if (code === 200) {
            this.previewData = data;
            this.previewOpen = true;
            await this.service.render();
        }
    }

    // ── 미리보기 ──

    public closePreview() {
        this.previewOpen = false;
        this.previewData = null;
        this.service.render();
    }

    // ── OCR ──

    public async loadOcrModels() {
        const { code, data } = await wiz.call('ocr_models');
        if (code === 200) this.ocrModels = data;
    }

    public hasOcrVariant(item: any): boolean {
        return item.variants?.some((v: any) => v.variant === 'ocr');
    }

    public hasEmbeddingVariant(item: any): boolean {
        return item.variants?.some((v: any) => v.variant === 'embedding');
    }

    public hasVectorStatusVariant(item: any): boolean {
        return item.variants?.some((v: any) => v.variant === 'vector_status');
    }

    public hasOriginalVariant(item: any): boolean {
        return item.variants?.some((v: any) => ['pdf', 'hwp', 'doc', 'docx'].includes(v.variant));
    }

    public getOcrPendingCount(): number {
        return this.browseItems.filter((item: any) =>
            item.type === 'filegroup' && this.hasOriginalVariant(item) && !this.hasOcrVariant(item)
        ).length;
    }

    public getOcrDoneCount(): number {
        return this.browseItems.filter((item: any) =>
            item.type === 'filegroup' && this.hasOcrVariant(item)
        ).length;
    }

    public getEmbeddingPendingCount(): number {
        return this.browseItems.filter((item: any) =>
            item.type === 'filegroup' && this.hasOcrVariant(item) && !this.hasEmbeddingVariant(item)
        ).length;
    }

    public getEmbeddingDoneCount(): number {
        return this.browseItems.filter((item: any) =>
            item.type === 'filegroup' && this.hasEmbeddingVariant(item)
        ).length;
    }

    public toggleBrowseSort(field: string) {
        if (this.browseSortField === field) {
            if (this.browseSortDesc) {
                this.browseSortDesc = false;
            } else {
                // 3rd click: reset sort
                this.browseSortField = '';
            }
        } else {
            this.browseSortField = field;
            this.browseSortDesc = true;
        }
        this.applyBrowseSort();
        this.service.render();
    }

    private applyBrowseSort() {
        if (!this.browseSortField) return;
        const field = this.browseSortField;
        const desc = this.browseSortDesc;
        this.browseItems.sort((a: any, b: any) => {
            // folders always first
            if (a.type === 'folder' && b.type !== 'folder') return -1;
            if (a.type !== 'folder' && b.type === 'folder') return 1;
            if (a.type === 'folder' && b.type === 'folder') return 0;
            // filegroups: check variant existence
            const aHas = field === 'ocr' ? this.hasOcrVariant(a) : field === 'embedding' ? this.hasEmbeddingVariant(a) : this.hasVectorStatusVariant(a);
            const bHas = field === 'ocr' ? this.hasOcrVariant(b) : field === 'embedding' ? this.hasEmbeddingVariant(b) : this.hasVectorStatusVariant(b);
            if (aHas === bHas) return 0;
            // desc=true: unprocessed first (false before true)
            if (desc) return aHas ? 1 : -1;
            // asc: processed first (true before false)
            return aHas ? -1 : 1;
        });
    }

    // PDF를 HWP/DOC보다 우선 선택 (pypdfium2는 PDF만 처리 가능)
    private findBestOriginalVariant(item: any): any {
        if (!item.variants) return null;
        return item.variants.find((v: any) => v.variant === 'pdf') || null;
    }

    public async requestOcr() {
        if (this.selectedBrowseKeys.size > 0) {
            // 선택된 항목만 OCR
            const selectedItems: any[] = [];
            for (const item of this.browseItems) {
                if (!this.isBrowseSelected(item)) continue;
                if (item.type === 'filegroup' && this.hasOriginalVariant(item)) {
                    const original = this.findBestOriginalVariant(item);
                    if (original) selectedItems.push({ type: 'file', path: original.path });
                } else if (item.type === 'folder') {
                    selectedItems.push({ type: 'folder', path: item.path });
                }
            }
            if (selectedItems.length === 0) {
                await this.service.modal.show({
                    title: 'OCR 실행',
                    message: '선택한 항목 중 OCR 가능한 파일이 없습니다.\n(PDF/HWP/DOC 파일을 선택해주세요)',
                    action: '확인', status: 'warning', actionBtn: 'warning'
                });
                return;
            }
            const fileCount = selectedItems.filter((s: any) => s.type === 'file').length;
            const folderCount = selectedItems.filter((s: any) => s.type === 'folder').length;
            let desc = '';
            if (fileCount > 0 && folderCount > 0) desc = `파일 ${fileCount}개, 폴더 ${folderCount}개`;
            else if (fileCount > 0) desc = `${fileCount}개 파일`;
            else desc = `${folderCount}개 폴더`;

            const res = await this.service.modal.show({
                title: 'OCR 실행',
                message: `선택한 ${desc}에 대해 OCR을 실행하시겠습니까?\n모델: ${this.selectedOcrModel}`,
                action: '실행', cancel: '취소', status: 'success', actionBtn: 'success'
            });
            if (!res) return;
            await this.runOcrStream('selected', { selected: selectedItems });
        } else {
            const pending = this.getOcrPendingCount();
            if (pending === 0) return;
            const res = await this.service.modal.show({
                title: 'OCR 실행',
                message: `현재 폴더의 ${pending}개 파일에 대해 OCR을 실행하시겠습니까?\n모델: ${this.selectedOcrModel}`,
                action: '실행', cancel: '취소', status: 'success', actionBtn: 'success'
            });
            if (!res) return;
            await this.runOcrStream('folder');
        }
    }

    public async requestOcrFile(item: any, event: Event) {
        event.stopPropagation();
        const original = this.findBestOriginalVariant(item);
        if (!original) return;

        await this.runOcrStream('file', { paths: [original.path] });
    }

    public async cancelOcr() {
        this.isOcrRunning = false;
        if (this.ocrAbortController) {
            this.ocrAbortController.abort();
            this.ocrAbortController = null;
        }
        await this.service.render();
    }

    public getOcrProgressPercent(): number {
        const p = this.ocrProgress;
        if (!p) return 0;
        if (p.type === 'complete') return 100;
        if (p.type === 'start') return 0;
        if (this.ocrTotalPages > 0) {
            return Math.round((this.ocrDonePages / this.ocrTotalPages) * 100);
        }
        const total = p.total || 1;
        const index = (p.index || 0);
        return Math.round((index / total) * 100);
    }

    public getOcrStatusText(): string {
        const p = this.ocrProgress;
        if (!p) return '';
        if (p.type === 'start') return `${p.total}개 파일 OCR 시작 (${p.model})`;
        if (p.type === 'file_start') return `[${p.index + 1}/${p.total}] ${p.file} (${p.total_pages}페이지)`;
        if (p.type === 'page_done') return `[${p.index + 1}] ${p.file} — ${p.page}/${p.total_pages} 페이지`;
        if (p.type === 'file_done') return `[${p.index + 1}] ${p.file} 완료`;
        if (p.type === 'file_error') return `[${p.index + 1}] ${p.file} 오류: ${p.message}`;
        if (p.type === 'complete') return `완료: ${p.processed}건 성공, ${p.errors}건 오류`;
        return '';
    }

    // HWP "failed to load document" 등 비-PDF 파일 에러를 숨기는 필터
    private isHwpLoadError(log: any): boolean {
        if (log.type !== 'file_error') return false;
        const msg = (log.message || '').toLowerCase();
        return msg.includes('failed to load document') || msg.includes('load document') || msg.includes('is not a valid pdf');
    }

    public getFilteredOcrLog(): any[] {
        return this.ocrLog.filter((log: any) => !this.isHwpLoadError(log)).slice(-8);
    }

    private async runOcrStream(scope: string, opts?: { paths?: string[], selected?: any[] }) {
        this.isOcrRunning = true;
        this.ocrProgress = null;
        this.ocrLog = [];
        this.ocrTotalPages = 0;
        this.ocrDonePages = 0;
        await this.service.render();

        await this._runOcrSSE(this.selected.id, scope, {
            path: this.browsePath,
            ...opts,
        });

        // SSE 완료 후 처리할 파일이 없었으면 안내 메시지
        const ocrComplete = this.ocrLog.find((e: any) => e.type === 'complete');
        if (ocrComplete && ocrComplete.total === 0) {
            this.isOcrRunning = false;
            await this.service.render();
            await this.service.modal.show({
                title: 'OCR',
                message: '처리할 파일이 없습니다.',
                action: '확인', status: 'warning', actionBtn: 'warning'
            });
        }

        this.isOcrRunning = false;
        this.ocrAbortController = null;
        await this.loadBrowse();
        await this.service.render();
    }

    public async requestOcrCollections() {
        if (this.selectedIds.size === 0) return;
        const count = this.selectedIds.size;
        const res = await this.service.modal.show({
            title: 'OCR 실행',
            message: `선택한 ${count}개 컬렉션의 OCR 미완료 파일에 대해 OCR을 실행하시겠습니까?\n모델: ${this.selectedOcrModel}`,
            action: '실행', cancel: '취소', status: 'success', actionBtn: 'success'
        });
        if (!res) return;

        this.isOcrRunning = true;
        this.ocrProgress = null;
        this.ocrLog = [];
        this.ocrTotalPages = 0;
        this.ocrDonePages = 0;
        await this.service.render();

        for (const cid of Array.from(this.selectedIds)) {
            if (!this.isOcrRunning) break;
            const col = this.collections.find((c: any) => c.id === cid);
            this.ocrLog.push({ type: 'info', message: `컬렉션: ${col?.name || cid.slice(0, 8)}...` });
            await this.service.render();
            await this._runOcrSSE(cid, 'collection');
        }

        this.isOcrRunning = false;
        this.ocrAbortController = null;
        await this.loadCollections();
        await this.service.render();
    }

    private async _runOcrSSE(collectionId: string, scope: string, opts?: any) {
        this.ocrAbortController = new AbortController();

        const formData = new FormData();
        formData.append('id', collectionId);
        formData.append('model', this.selectedOcrModel);
        formData.append('scope', scope);
        if (opts?.path) formData.append('path', opts.path);
        if (opts?.paths) formData.append('paths', JSON.stringify(opts.paths));
        if (opts?.selected) formData.append('selected', JSON.stringify(opts.selected));

        try {
            const response = await fetch(
                '/wiz/api/page.collections/run_ocr',
                { method: 'POST', body: formData, signal: this.ocrAbortController.signal }
            );

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            if (event.type === 'heartbeat') continue;
                            this.ocrProgress = event;
                            this.ocrLog.push(event);
                            if (event.type === 'file_start') {
                                this.ocrTotalPages += event.total_pages || 0;
                            } else if (event.type === 'page_done') {
                                this.ocrDonePages++;
                            }
                            await this.service.render();
                        } catch {}
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                this.ocrLog.push({ type: 'error', message: String(e) });
            }
        }
        this.ocrAbortController = null;
    }

    // ── OCR 결과 뷰어 ──

    public async openOcrViewer(item: any, event?: Event) {
        if (event) event.stopPropagation();
        const pdfVariant = item.variants?.find((v: any) => v.variant === 'pdf');
        if (!pdfVariant) return;

        this.ocrViewerLoading = true;
        this.ocrViewerOpen = true;
        this.ocrViewerPage = 1;
        this.ocrViewerPath = pdfVariant.path;
        this.ocrViewerData = null;
        await this.service.render();

        const { code, data } = await wiz.call('ocr_preview', {
            id: this.selected.id,
            path: pdfVariant.path,
        });

        if (code === 200) {
            // Normalize legacy OCR data (null fields)
            if (!data.total_pages && data.pages) {
                data.total_pages = data.pages.length;
            }
            if (!data.source_file) {
                data.source_file = this.ocrViewerPath.split('/').pop()?.replace('.pdf', '') || '알 수 없음';
            }
            if (!data.model) {
                data.model = '알 수 없음';
            }
            this.ocrViewerData = data;
        } else {
            this.ocrViewerOpen = false;
            await this.service.modal.error(data?.message || 'OCR 결과를 불러올 수 없습니다.');
        }
        this.ocrViewerLoading = false;
        await this.service.render();
    }

    public closeOcrViewer() {
        this.ocrViewerOpen = false;
        this.ocrViewerData = null;
        this.ocrViewerPath = '';
        this.ocrViewerPage = 1;
        this.service.render();
    }

    public getOcrViewerPageText(): string {
        if (!this.ocrViewerData?.pages) return '';
        const page = this.ocrViewerData.pages.find((p: any) => p.page === this.ocrViewerPage);
        return page?.text || '';
    }

    public getOcrViewerImageUrl(): string {
        return `/wiz/api/page.collections/pdf_page_image?id=${encodeURIComponent(this.selected.id)}&path=${encodeURIComponent(this.ocrViewerPath)}&page=${this.ocrViewerPage}`;
    }

    public ocrViewerPrev() {
        if (this.ocrViewerPage > 1) {
            this.ocrViewerPage--;
            this.service.render();
        }
    }

    public ocrViewerNext() {
        if (this.ocrViewerData && this.ocrViewerPage < this.ocrViewerData.total_pages) {
            this.ocrViewerPage++;
            this.service.render();
        }
    }

    public ocrViewerGoTo(page: any) {
        const p = Number(page);
        if (p >= 1 && this.ocrViewerData && p <= this.ocrViewerData.total_pages) {
            this.ocrViewerPage = p;
            this.service.render();
        }
    }

    public getOcrViewerVisiblePages(): (number | string)[] {
        if (!this.ocrViewerData) return [];
        const total = this.ocrViewerData.total_pages;
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

        const pages: (number | string)[] = [];
        const current = this.ocrViewerPage;

        pages.push(1);
        if (current > 3) pages.push('...');

        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);
        for (let i = start; i <= end; i++) pages.push(i);

        if (current < total - 2) pages.push('...');
        if (total > 1) pages.push(total);

        return pages;
    }

    public async copyOcrText() {
        const text = this.getOcrViewerPageText();
        if (!text) return;
        try {
            await navigator.clipboard.writeText(text);
        } catch {}
    }

    // ── 벡터 DB 삽입 ──

    public hasSelectedOcr(): boolean {
        if (this.selectedIds.size === 0) return false;
        return this.collections.some((c: any) =>
            this.selectedIds.has(c.id) && c.stats?.ocr > 0
        );
    }

    public hasSelectedEmbedding(): boolean {
        if (this.selectedIds.size === 0) return false;
        return this.collections.some((c: any) =>
            this.selectedIds.has(c.id) && c.stats?.embedding > 0
        );
    }

    // ── 상세뷰 임베딩 / 벡터 카운트 ──

    public getVectorPendingCount(): number {
        return this.browseItems.filter((item: any) =>
            item.type === 'filegroup' && this.hasEmbeddingVariant(item) && !this.hasVectorStatusVariant(item)
        ).length;
    }

    public getVectorDoneCount(): number {
        return this.browseItems.filter((item: any) =>
            item.type === 'filegroup' && this.hasVectorStatusVariant(item)
        ).length;
    }

    // ── 상세뷰: 임베딩 실행 (파일/폴더 선택) ──

    public async requestEmbeddingBrowse() {
        if (this.selectedBrowseKeys.size > 0) {
            // 선택된 항목만 임베딩
            const selectedItems: any[] = [];
            for (const item of this.browseItems) {
                if (!this.isBrowseSelected(item)) continue;
                if (item.type === 'filegroup' && this.hasOcrVariant(item)) {
                    const original = this.findBestOriginalVariant(item);
                    if (original) selectedItems.push({ type: 'file', path: original.path });
                } else if (item.type === 'folder') {
                    selectedItems.push({ type: 'folder', path: item.path });
                }
            }
            if (selectedItems.length === 0) {
                await this.service.modal.show({
                    title: '임베딩 실행',
                    message: '선택한 항목 중 임베딩 가능한 파일이 없습니다.\n(OCR이 완료된 파일을 선택해주세요)',
                    action: '확인', status: 'warning', actionBtn: 'warning'
                });
                return;
            }
            const fileCount = selectedItems.filter((s: any) => s.type === 'file').length;
            const folderCount = selectedItems.filter((s: any) => s.type === 'folder').length;
            let desc = '';
            if (fileCount > 0 && folderCount > 0) desc = `파일 ${fileCount}개, 폴더 ${folderCount}개`;
            else if (fileCount > 0) desc = `${fileCount}개 파일`;
            else desc = `${folderCount}개 폴더`;

            const res = await this.service.modal.show({
                title: '임베딩 실행',
                message: `선택한 ${desc}에 대해 임베딩을 실행하시겠습니까?\n이미 임베딩된 파일은 건너뜁니다.`,
                action: '실행', cancel: '취소', status: 'success', actionBtn: 'success'
            });
            if (!res) return;
            await this.runEmbeddingStream('selected', { selected: selectedItems });
        } else {
            const pending = this.getEmbeddingPendingCount();
            if (pending === 0) return;
            const res = await this.service.modal.show({
                title: '임베딩 실행',
                message: `현재 폴더의 ${pending}개 파일에 대해 임베딩을 실행하시겠습니까?\n이미 임베딩된 파일은 건너뜁니다.`,
                action: '실행', cancel: '취소', status: 'success', actionBtn: 'success'
            });
            if (!res) return;
            await this.runEmbeddingStream('folder');
        }
    }

    private async runEmbeddingStream(scope: string, opts?: { selected?: any[] }) {
        this.isEmbeddingRunning = true;
        this.embeddingProgress = null;
        this.embeddingLog = [];
        await this.service.render();

        await this._runEmbeddingSSE(this.selected.id, scope, {
            path: this.browsePath,
            ...opts,
        });

        const embComplete = this.embeddingLog.find((e: any) => e.type === 'complete');
        if (embComplete && embComplete.total === 0) {
            this.isEmbeddingRunning = false;
            await this.service.render();
            await this.service.modal.show({
                title: '임베딩',
                message: '처리할 파일이 없습니다.\nOCR이 완료된 파일을 선택해주세요.',
                action: '확인', status: 'warning', actionBtn: 'warning'
            });
        }

        this.isEmbeddingRunning = false;
        this.embeddingAbortController = null;
        await this.loadBrowse();
        await this.service.render();
    }

    // ── 상세뷰: 벡터 DB 삽입 (파일/폴더 선택) ──

    public async requestVectorInsertBrowse() {
        if (this.selectedBrowseKeys.size > 0) {
            // 선택된 항목만 벡터 DB 삽입
            const selectedItems: any[] = [];
            for (const item of this.browseItems) {
                if (!this.isBrowseSelected(item)) continue;
                if (item.type === 'filegroup' && this.hasEmbeddingVariant(item)) {
                    const original = item.variants.find((v: any) => ['pdf', 'hwp', 'doc', 'docx'].includes(v.variant));
                    if (original) selectedItems.push({ type: 'file', path: original.path });
                } else if (item.type === 'folder') {
                    selectedItems.push({ type: 'folder', path: item.path });
                }
            }
            if (selectedItems.length === 0) {
                await this.service.modal.show({
                    title: '벡터 DB 삽입',
                    message: '선택한 항목 중 벡터 DB 삽입 가능한 파일이 없습니다.\n(임베딩이 완료된 파일을 선택해주세요)',
                    action: '확인', status: 'warning', actionBtn: 'warning'
                });
                return;
            }
            const fileCount = selectedItems.filter((s: any) => s.type === 'file').length;
            const folderCount = selectedItems.filter((s: any) => s.type === 'folder').length;
            let desc = '';
            if (fileCount > 0 && folderCount > 0) desc = `파일 ${fileCount}개, 폴더 ${folderCount}개`;
            else if (fileCount > 0) desc = `${fileCount}개 파일`;
            else desc = `${folderCount}개 폴더`;

            const res = await this.service.modal.show({
                title: '벡터 DB 삽입',
                message: `선택한 ${desc}을 벡터 DB에 삽입하시겠습니까?\n이미 삽입된 파일은 건너뜁니다.`,
                action: '삽입', cancel: '취소', status: 'success', actionBtn: 'success'
            });
            if (!res) return;
            await this.runVectorInsertStream('selected', { selected: selectedItems });
        } else {
            const pending = this.getVectorPendingCount();
            if (pending === 0) return;
            const res = await this.service.modal.show({
                title: '벡터 DB 삽입',
                message: `현재 폴더의 ${pending}개 파일을 벡터 DB에 삽입하시겠습니까?\n이미 삽입된 파일은 건너뜁니다.`,
                action: '삽입', cancel: '취소', status: 'success', actionBtn: 'success'
            });
            if (!res) return;
            await this.runVectorInsertStream('folder');
        }
    }

    private async runVectorInsertStream(scope: string, opts?: { selected?: any[], force?: boolean }) {
        this.isVectorInserting = true;
        this.vectorInsertProgress = null;
        this.vectorInsertLog = [];
        await this.service.render();

        await this._runVectorInsertSSE(this.selected.id, scope, {
            path: this.browsePath,
            ...opts,
        });

        const vecComplete = this.vectorInsertLog.find((e: any) => e.type === 'complete');
        if (vecComplete && vecComplete.total === 0) {
            this.isVectorInserting = false;
            await this.service.render();
            await this.service.modal.show({
                title: '벡터 DB',
                message: '처리할 파일이 없습니다.\n임베딩이 완료된 파일을 선택해주세요.',
                action: '확인', status: 'warning', actionBtn: 'warning'
            });
        } else if (vecComplete && vecComplete.total > 0 && vecComplete.inserted === 0 && vecComplete.skipped === vecComplete.total && !opts?.force) {
            // 모든 파일이 skip된 경우 — 강제 재삽입 제안
            this.isVectorInserting = false;
            await this.service.render();
            const retry = await this.service.modal.show({
                title: '벡터 DB 재삽입',
                message: `${vecComplete.total}개 파일이 모두 이미 삽입된 것으로 표시되어 건너뛰었습니다.\nMilvus에 실제 데이터가 없을 수 있습니다.\n강제로 다시 삽입하시겠습니까?`,
                action: '강제 재삽입', cancel: '취소',
                status: 'warning', actionBtn: 'warning'
            });
            if (retry) {
                await this.runVectorInsertStream(scope, { ...opts, force: true });
                return;
            }
        }

        this.isVectorInserting = false;
        this.vectorAbortController = null;
        await this.loadBrowse();
        await this.service.render();
    }

    public async requestVectorInsertCollections(forceMode: boolean = false) {
        if (this.selectedIds.size === 0) return;
        if (!this.hasSelectedEmbedding()) return;

        const selected = this.collections.filter((c: any) =>
            this.selectedIds.has(c.id) && c.stats?.embedding > 0
        );
        const count = selected.length;
        const totalEmb = selected.reduce((sum: number, c: any) => sum + (c.stats?.embedding || 0), 0);

        const confirmMsg = forceMode
            ? `선택한 ${count}개 컬렉션 (임베딩 ${totalEmb}개)을 강제로 벡터 DB에 재삽입하시겠습니까?\n기존 상태 파일을 무시하고 모두 재처리합니다.`
            : `선택한 ${count}개 컬렉션 (임베딩 ${totalEmb}개)을 벡터 DB에 삽입하시겠습니까?\n이미 삽입된 파일은 건너뜁니다.`;

        const res = await this.service.modal.show({
            title: forceMode ? '벡터 DB 강제 재삽입' : '벡터 DB 삽입',
            message: confirmMsg,
            action: forceMode ? '강제 재삽입' : '삽입',
            cancel: '취소',
            status: forceMode ? 'warning' : 'success',
            actionBtn: forceMode ? 'warning' : 'success'
        });
        if (!res) return;

        this.isVectorInserting = true;
        this.vectorInsertProgress = null;
        this.vectorInsertLog = [];
        await this.service.render();

        let allSkipped = true;
        let totalSkipped = 0;
        let totalFiles = 0;

        for (const col of selected) {
            if (!this.isVectorInserting) break;
            this.vectorInsertLog.push({ type: 'info', message: `컬렉션: ${col.name || col.id.slice(0, 8)}...` });
            await this.service.render();
            await this._runVectorInsertSSE(col.id, 'collection', forceMode ? { force: true } : undefined);

            // 각 컬렉션의 complete 이벤트 확인
            const lastComplete = [...this.vectorInsertLog].reverse().find((e: any) => e.type === 'complete');
            if (lastComplete) {
                totalFiles += lastComplete.total || 0;
                totalSkipped += lastComplete.skipped || 0;
                if (lastComplete.inserted > 0) allSkipped = false;
            }
        }

        this.isVectorInserting = false;
        this.vectorAbortController = null;

        // 모든 컬렉션에서 전부 skip된 경우 강제 재삽입 제안
        if (allSkipped && totalFiles > 0 && !forceMode) {
            await this.service.render();
            const retry = await this.service.modal.show({
                title: '벡터 DB 재삽입',
                message: `${totalFiles}개 파일이 모두 이미 삽입된 것으로 표시되어 건너뛰었습니다.\nMilvus에 실제 데이터가 없을 수 있습니다.\n강제로 다시 삽입하시겠습니까?`,
                action: '강제 재삽입', cancel: '취소',
                status: 'warning', actionBtn: 'warning'
            });
            if (retry) {
                await this.requestVectorInsertCollections(true);
                return;
            }
        }

        await this.loadCollections();
        await this.service.render();
    }

    public async cancelVectorInsert() {
        this.isVectorInserting = false;
        if (this.vectorAbortController) {
            this.vectorAbortController.abort();
            this.vectorAbortController = null;
        }
        await this.service.render();
    }

    public getVectorInsertStatusText(): string {
        const p = this.vectorInsertProgress;
        if (!p) return '';
        if (p.type === 'scanning') return '파일 검색 중...';
        if (p.type === 'milvus_init') return 'Milvus 컬렉션 준비 중...';
        if (p.type === 'milvus_ready') return 'Milvus 컬렉션 준비 완료';
        if (p.type === 'start') return `${p.total}개 파일 삽입 시작`;
        if (p.type === 'file_start') return `[${(p.index || 0) + 1}/${p.total}] ${p.file}`;
        if (p.type === 'file_done') return `[${(p.index || 0) + 1}/${p.total}] ${p.file} — ${p.chunks}건 삽입`;
        if (p.type === 'file_skip') return `[${(p.index || 0) + 1}/${p.total}] ${p.file} 건너뜀`;
        if (p.type === 'file_error') return `[${(p.index || 0) + 1}/${p.total}] ${p.file} 오류`;
        if (p.type === 'complete') return `완료: ${p.inserted}건 삽입, ${p.skipped}건 건너뜀, ${p.errors}건 오류`;
        return '';
    }

    public getVectorInsertPercent(): number {
        const p = this.vectorInsertProgress;
        if (!p) return 0;
        if (p.type === 'scanning') return 0;
        if (p.type === 'complete') return 100;
        const total = p.total || 1;
        const index = p.index || 0;
        return Math.round((index / total) * 100);
    }

    private async _runVectorInsertSSE(collectionId: string, scope?: string, opts?: any) {
        this.vectorAbortController = new AbortController();

        const formData = new FormData();
        formData.append('id', collectionId);
        formData.append('scope', scope || 'collection');
        if (opts?.path) formData.append('path', opts.path);
        if (opts?.selected) formData.append('selected', JSON.stringify(opts.selected));
        if (opts?.force) formData.append('force', 'true');

        try {
            const response = await fetch(
                '/wiz/api/page.collections/run_vector_insert',
                { method: 'POST', body: formData, signal: this.vectorAbortController.signal }
            );

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            this.vectorInsertProgress = event;
                            this.vectorInsertLog.push(event);
                            await this.service.render();
                        } catch {}
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                this.vectorInsertLog.push({ type: 'error', message: String(e) });
            }
        }
        this.vectorAbortController = null;
    }

    // ── 임베딩 ──

    public async requestEmbeddingCollections() {
        if (this.selectedIds.size === 0) return;
        if (!this.hasSelectedOcr()) return;

        const selected = this.collections.filter((c: any) =>
            this.selectedIds.has(c.id) && c.stats?.ocr > 0
        );
        const count = selected.length;
        const totalOcr = selected.reduce((sum: number, c: any) => sum + (c.stats?.ocr || 0), 0);

        const res = await this.service.modal.show({
            title: '임베딩 실행',
            message: `선택한 ${count}개 컬렉션 (OCR ${totalOcr}개)에 대해 임베딩을 실행하시겠습니까?\n이미 임베딩된 파일은 건너뜁니다.`,
            action: '실행',
            cancel: '취소',
            status: 'success',
            actionBtn: 'success'
        });
        if (!res) return;

        this.isEmbeddingRunning = true;
        this.embeddingProgress = null;
        this.embeddingLog = [];
        await this.service.render();

        for (const col of selected) {
            if (!this.isEmbeddingRunning) break;
            this.embeddingLog.push({ type: 'info', message: `컬렉션: ${col.name || col.id.slice(0, 8)}...` });
            await this.service.render();
            await this._runEmbeddingSSE(col.id, 'collection');
        }

        this.isEmbeddingRunning = false;
        this.embeddingAbortController = null;
        await this.loadCollections();
        await this.service.render();
    }

    public async cancelEmbedding() {
        this.isEmbeddingRunning = false;
        if (this.embeddingAbortController) {
            this.embeddingAbortController.abort();
            this.embeddingAbortController = null;
        }
        await this.service.render();
    }

    public getEmbeddingStatusText(): string {
        const p = this.embeddingProgress;
        if (!p) return '';
        if (p.type === 'scanning') return '파일 검색 중...';
        if (p.type === 'start') return `${p.total}개 파일 임베딩 시작`;
        if (p.type === 'file_start') return `[${(p.index || 0) + 1}/${p.total}] ${p.file}`;
        if (p.type === 'file_done') return `[${(p.index || 0) + 1}/${p.total}] ${p.file} — ${p.chunks}개 청크`;
        if (p.type === 'file_skip') return `[${(p.index || 0) + 1}/${p.total}] ${p.file} 건너뜀`;
        if (p.type === 'file_error') return `[${(p.index || 0) + 1}/${p.total}] ${p.file} 오류`;
        if (p.type === 'complete') return `완료: ${p.processed}건 성공, ${p.skipped}건 건너뜀, ${p.errors}건 오류`;
        return '';
    }

    public getEmbeddingProgressPercent(): number {
        const p = this.embeddingProgress;
        if (!p) return 0;
        if (p.type === 'scanning') return 0;
        if (p.type === 'complete') return 100;
        const total = p.total || 1;
        const index = p.index || 0;
        return Math.round((index / total) * 100);
    }

    private async _runEmbeddingSSE(collectionId: string, scope?: string, opts?: any) {
        this.embeddingAbortController = new AbortController();

        const formData = new FormData();
        formData.append('id', collectionId);
        formData.append('scope', scope || 'collection');
        if (opts?.path) formData.append('path', opts.path);
        if (opts?.selected) formData.append('selected', JSON.stringify(opts.selected));

        try {
            const response = await fetch(
                '/wiz/api/page.collections/run_embedding',
                { method: 'POST', body: formData, signal: this.embeddingAbortController.signal }
            );

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            this.embeddingProgress = event;
                            this.embeddingLog.push(event);
                            await this.service.render();
                        } catch {}
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                this.embeddingLog.push({ type: 'error', message: String(e) });
            }
        }
        this.embeddingAbortController = null;
    }

    public getProcessingRate(done: number, total: number): string {
        if (!total) return '—';
        if (done >= total) return '완료';
        if (!done) return '대기';
        return `${Math.round((done / total) * 100)}%`;
    }

    public getProcessingColor(done: number, total: number): string {
        if (!total) return 'text-gray-400';
        if (done >= total) return 'text-emerald-600';
        if (!done) return 'text-gray-400';
        return 'text-amber-600';
    }

    // ── 유틸 ──

    public getVariantLabel(variant: string): string {
        const map: any = {
            'hwp': 'HWP', 'pdf': 'PDF', 'doc': 'DOC', 'docx': 'DOCX',
            'ocr': 'OCR', 'embedding': 'EMB',
            'ocr_status': 'OCR상태', 'embedding_status': 'EMB상태', 'vector_status': 'VEC상태',
        };
        return map[variant] || variant.toUpperCase();
    }

    public getVariantColor(variant: string): string {
        if (variant === 'hwp') return 'bg-blue-100 text-blue-700';
        if (variant === 'pdf') return 'bg-red-100 text-red-700';
        if (variant === 'ocr') return 'bg-emerald-100 text-emerald-700';
        if (variant === 'embedding') return 'bg-violet-100 text-violet-700';
        if (variant.includes('status')) return 'bg-gray-100 text-gray-500';
        return 'bg-gray-100 text-gray-600';
    }

    public getVariantIcon(variant: string): string {
        if (variant === 'hwp') return 'fa fa-file-alt text-blue-500';
        if (variant === 'pdf') return 'fa fa-file-pdf text-red-500';
        if (variant === 'doc' || variant === 'docx') return 'fa fa-file-word text-blue-600';
        if (variant === 'ocr') return 'fa fa-file-code text-emerald-500';
        if (variant === 'embedding') return 'fa fa-file-code text-violet-500';
        return 'fa fa-file text-gray-400';
    }

    public getMainVariants(variants: any[]): any[] {
        return variants.filter((v: any) => !v.variant.includes('status'));
    }

    public formatNumber(n: number): string {
        if (!n) return '0';
        return n.toLocaleString();
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public jsonPreview(obj: any): string {
        try { return JSON.stringify(obj, null, 2); }
        catch { return String(obj); }
    }
}

export default PageCollectionsComponent;